import React from 'react'
import { Box, Tooltip } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import { DateField } from './DateRangeFilter'

/**
 * "As of" date picker — OTB reconstruction.
 *
 * When set, the backend reconstructs the bookings universe as it looked
 * on that historical date: only bookings created on or before it and
 * not yet cancelled at that moment. Status filter also relaxes so
 * future 'reserved' bookings appear (they exist in OTB but aren't
 * contract/closed yet). Cleared = live view (fact_booking_current).
 *
 * Controlled component:
 *   props.value    = 'YYYY-MM-DD' | '' (empty means no as-of filter)
 *   props.onChange = (nextValue, opts?) => void
 *
 * Emits 'pending' — user must Apply to fetch. The picker's own clear
 * button goes back to the live view.
 */
export default function AsOfSlicer({ value, onChange }) {
	const emit = (v) => onChange(v || '', { intent: 'pending' })
	return (
		<DateField
			value={value || ''}
			onChange={emit}
			disableFuture
			cleanable
			label={<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, pointerEvents: 'auto' }}>
				As of
				<Tooltip arrow placement="top"
				         componentsProps={{ tooltip: { sx: { maxWidth: 320, p: 1.5 } }}}
				         title={
					<Box sx={{ fontSize: 13 }}>
						Reconstructs the OTB (on-the-books) view as it looked on
						the chosen date. Bookings created after that date, or
						cancelled by then, are excluded. Empty = live view.
					</Box>
				}>
					<Box component="span" sx={{ display: 'inline-flex', cursor: 'help' }}>
						<IconSeeker icon="circle-question" sx={{ fontSize: 11 }}/>
					</Box>
				</Tooltip>
			</Box>}
		/>
	)
}
